/**
 * EntryIcon —— 镜像 iOS EntryIcon.swift。
 * 优先显示原版图片（pixelated 无插值缩放）；无图时按 entry.kind
 * 显示对应 Lucide 图标，背景用模块/分类 tint。
 */

import { resolveImage } from '@/lib/assets';
import { resolveSymbol } from '@/lib/icons';
import { entryKindSymbolName } from '@/core/models';
import { cn } from '@/lib/cn';
import type { EncyclopediaEntry } from '@/core/models';
import { TintBackground, TintText } from '@/lib/tint';

interface EntryIconProps {
  entry: Pick<EncyclopediaEntry, 'imageKey' | 'kind' | 'nameZh' | 'topicID'>;
  size?: number;
  className?: string;
}

export function EntryIcon({ entry, size = 44, className }: EntryIconProps) {
  const url = resolveImage(entry.imageKey);

  if (url) {
    return (
      <img
        src={url}
        width={size}
        height={size}
        alt={entry.nameZh}
        loading="lazy"
        decoding="async"
        className={cn('pixelated rounded-companion object-contain', className)}
        style={{ width: size, height: size }}
      />
    );
  }

  const Icon = resolveSymbol(entryKindSymbolName[entry.kind]);
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-companion',
        TintBackground.forEntry(entry),
        className,
      )}
      style={{ width: size, height: size }}
    >
      <Icon className={TintText.forEntry(entry)} size={Math.round(size * 0.55)} />
    </div>
  );
}
